import type { CoreElement } from '@tunasong/schemas'
import type { TunaEditor, TunaPlugin } from '../plugin-types.js'
import React from 'react'

const decorationPluginsCache = new WeakMap<TunaPlugin[], TunaPlugin[]>()

const getDecorationPlugins = (pluginList: TunaPlugin[]) => {
  let cached = decorationPluginsCache.get(pluginList)
  if (!cached) {
    cached = pluginList.filter(p => p.components?.BlockDecoration)
    decorationPluginsCache.set(pluginList, cached)
  }
  return cached
}

export const hasBlockDecorationPlugins = (editor: TunaEditor) =>
  getDecorationPlugins(editor.meta.pluginList).length > 0

/**
 * Render every plugin's `components.BlockDecoration` for the given block.
 * Each component is rendered as a real React element so its hooks (notably
 * `useEntityChildren` for note anchors / comment lookups) attach reactively
 * — re-renders happen automatically when the underlying data changes.
 *
 * Per-plugin filtering is the contributor's responsibility: components
 * should return `null` when the block doesn't match their criteria.
 */
export const renderBlockDecorations = (editor: TunaEditor, element: CoreElement) =>
  getDecorationPlugins(editor.meta.pluginList).map(plugin => {
    const Decoration = plugin.components?.BlockDecoration
    if (!Decoration) {
      return null
    }
    return <Decoration key={plugin.key} editor={editor} element={element} />
  })
